import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const PERSONAL_API_KEYS_QUERY_KEY = 'personalApiKeys';

export interface IPersonalApiKey extends Api.IBaseResourceModel {
	description?: string;
	scopes: string[];
	expirationDate?: string;
	lastUsedDate?: string;
	/** The full signed key value. Populated once, on creation, only; null on list/get. */
	key?: string;
}

export function useGetPersonalApiKeys({
	enabled,
	refetchOnWindowFocus = false,
}: {
	enabled: boolean;
	refetchOnWindowFocus?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		refetchOnWindowFocus,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IPersonalApiKey[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'personalapikeys',
				}),
				'GET'
			),
		queryKey: [PERSONAL_API_KEYS_QUERY_KEY],
		meta: {
			toastErrorMessage: 'Failed to load personal API keys',
		},
	});
}

export const invalidateGetPersonalApiKeys = () =>
	reactQueryClient.invalidateQueries({ queryKey: [PERSONAL_API_KEYS_QUERY_KEY] });
